<template>
  <v-container fluid class="inventoryjournal-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-journal`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Journal
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab-item :value="'tab-journal'">
            <v-card elevation="1" flat tile>
              <v-card-text>
                <v-row no-gutters>
                  <p class="text-h5">Edit Inventory Journal</p>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="['Inventory Journal']"
                        v-model="initvalue.journaltype"
                        v-on:change="onChangeJournal($event, 'journaltype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the journal type"
                      >
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['Inventory Adjustment', 'Inventory Transfer']"
                        v-model="initvalue.journalsubtype"
                        v-on:change="onChangeJournal($event, 'journalsubtype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Subtype"
                        persistent-hint
                        single-line
                        hint="Please choose the journal subtype"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        readonly
                        outlined
                        dense
                        v-model="journaldate"
                        label="Journal Date"
                        v-bind:value="journaldate"
                        v-on:change="
                          onChangeJournal($event, 'journaldate')
                        "
                        v-bind:error="errorindex == 1"
                        single-line
                        hint="Please choose the journal date"
                        persistent-hint
                      >
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="initvalue.locationid"
                        v-on:change="onChangeJournal($event, 'locationid')"
                        v-bind:error="errorindex == 6"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-form>
                      <v-text-field
                        class="mb-4"
                        v-model="initvalue.journalname"
                        v-on:change="
                          onChangeJournal($event, 'journalname')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Journal Name"
                        persistent-hint
                        single-line
                        hint="Enter the journal name"
                      >
                      </v-text-field>
                      <v-textarea
                        v-model="initvalue.journalnote"
                        v-on:change="onChangeJournal($event, 'journalnote')"
                        outlined
                        dense
                        persistent-hint
                        rows=1
                        label="Note"
                        hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/inventoryjournal/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updateInventoryJournal()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="1" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="!isNotEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; add_transaction={};">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/inventoryjournal/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  <v-col md="2" align="right">
                  </v-col>
                </v-row>
                <v-data-table
                  sort-by="tranrank"
                  :headers="header_item"
                  :items="transactions"
                  :items-per-page="500"
                  :footer-props="{'items-per-page-options': [500, 1000, 5000]}"
                  class="elevation-0"
                >
                  <template v-slot:top>
                    <v-dialog v-model="isDeleteTransaction" width="500">
                      <v-card>
                        <v-card-title> Delete this Item? </v-card-title>
                        <v-card-text>
                          {{ delete_transaction.itemname }}
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            outlined
                            @click="isDeleteTransaction = false"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="secondary"
                            class="button-shadow"
                            @click="deleteTransaction(delete_transaction)"
                            >Delete
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-slot:item.locationid="{ item }">
                    <p class="two-line">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationcode'] : '' }}</p>
                  </template>
                  <template v-slot:item.itemimage="{ item }">
                    <v-img
                      v-bind:lazy-src="item.itemimage"
                      min-width="50"
                      max-width="100"
                      v-bind:src="item.itemimage"
                    ></v-img>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      color="primary"
                      @click="updateTransactionDialog(item)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="primary"
                      @click="deleteTransactionDialog(item)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/inventoryjournal/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="locations.filter(brand=>brand.locationstatus=='Active').map(x => {
                      return {text: x.locationname, value: x._id};
                    })"
                    v-model="add_transaction.locationid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Location"
                    persistent-hint
                    single-line hint="Location">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="add_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == add_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="add_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    v-on:change="onChangeItem"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="add_transaction.increaseQty"
                    class="mb-4"
                    dense
                    placeholder="Increase"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Increase">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="add_transaction.decreaseQty"
                    class="mb-4"
                    dense
                    placeholder="Decrease"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Decrease">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="add_transaction.itemcost"
                    class="mb-4"
                    dense
                    placeholder="Cost"
                    persistent-hint
                    single-line hint="Cost">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="locations.filter(brand=>brand.locationstatus=='Active').map(x => {
                      return {text: x.locationname, value: x._id};
                    })"
                    v-model="edit_transaction.locationid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Location"
                    persistent-hint
                    single-line hint="Location">
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="edit_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="5">
                  <v-select
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == edit_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="edit_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    v-on:change="onChangeItemEdit"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.increaseQty"
                    class="mb-4"
                    dense
                    placeholder="Increase"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Increase">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.decreaseQty"
                    class="mb-4"
                    dense
                    placeholder="Decrease"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 0) this.value = 0;"
                    single-line hint="Decrease">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemcost"
                    class="mb-4"
                    dense
                    placeholder="Cost"
                    persistent-hint
                    single-line hint="Cost">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      header_item: [
        { text: 'Image', value: 'itemimage', width: '5%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Location', value: 'locationid', width: '10%' },
        { text: 'Increase', value: 'increaseQty', width: '10%'},
        { text: 'Decrease', value: 'decreaseQty', width: '10%'},
        { text: 'Cost', value: 'itemcost', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_file: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      initvalue: {},
      edit_journal: {},
      add_transaction: {},
      edit_transaction: {},

      delete_transaction: {},
      delete_file: {},
      
      upload: {filename: null,file: null},
      files: [],
      images: [],
      transactions: [],


      filename: null,
      uploadname: null,

      isAddTransaction: false,
      isEditTransaction: false,
      isDeleteFile: false,
      isDeleteTransaction: false, 
      isUploadFile: false,
      
      journaldate: null,
      menu_journaldate: false,   
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("Customer", ["customers"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("PayMethod", ["paymethods"]),
    ...mapState("Price", ["prices"]),
    ...mapState("PriceList", ["pricelists"]),
    ...mapState("Region", ["regions"]),
    ...mapState("Township", ["townships"]),
    ...mapState("InventoryJournal", ["isReceiving"]),
    ...mapState("User", ["users"]),
    isNotEditable(){
      let result = ['New'].indexOf(this.initvalue.journalstatus) == -1;
      return result;
    }
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Customer", ["getCustomersRequest"]),
    ...mapActions("File", ["insertInventoryJournalFile", "deleteFileRequest", "getInventoryJournalFiles"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("PayMethod", ["getPayMethodsRequest"]),
    ...mapActions("Price", ["getPricesRequest"]),
    ...mapActions("PriceList", ["getPriceListsRequest"]),
    ...mapActions("Region", ["getRegionsRequest"]),
    ...mapActions("InventoryJournal", ["getInventoryJournalRequest", "deleteIVJTransactionRequest", "updateInventoryJournalRequest", "insertIVJTransactionRequest", "updateIVJTransactionRequest"]),
    ...mapActions("Township", ["getTownshipsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),

    calculateTotal() {
      if(!this.transactions) return;
      
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, itemname: item.itemname, itemquantity: item.itemquantity};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      let response = await this.deleteIVJTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getInventoryJournalRequest(this.initvalue._id);
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.delete_file = {_id: item._id,filename: item.filename,};
    },
    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    findPriceByQuantity(prices, itemid, qty){
      let price = prices.find(price=> price.itemid==itemid && parseInt(qty)>=price.minqty && parseInt(qty)<=price.maxqty);
      return price;
    },
    async insertTransaction() {
      this.isAddTransaction = false;
      if(this.add_transaction.itemid==null || (this.add_transaction.increaseQty==null && this.add_transaction.decreaseQty==null) || this.add_transaction.itemcost==null) return;
      let payload = Object.assign({}, this.add_transaction, {journalid: this.initvalue._id});
      let response = await this.insertIVJTransactionRequest(payload);
      this.transactions.push(response);
      this.clearTransaction();
      this.getInventoryJournalRequest(this.initvalue._id);
    },
    onChangeItem(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(i=>i.pricelisttype=='Purchasing');
      if(!this.add_transaction.itemquantity) this.add_transaction.itemquantity = 1;
      let cost = this.findPriceByQuantity(pricelist.prices, item._id, this.add_transaction.itemquantity);
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.add_transaction.itemquantity,
        itemcost: cost!=null ? cost.listprice : 0,
      }
      this.add_transaction = Object.assign({}, this.add_transaction, update);
    },
    onChangeItemEdit(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let pricelist = this.pricelists.find(i=>i.pricelisttype=='Purchasing');
      if(!this.edit_transaction.itemquantity) this.edit_transaction.itemquantity = 1;
      let cost = this.findPriceByQuantity(pricelist.prices, item._id, this.edit_transaction.itemquantity);
      let update = {
        itemid: item._id,
        itemimage: item.itemimage, 
        itemname: item.itemname,
        itemquantity: this.edit_transaction.itemquantity,
        itemcost: cost!=null ? cost.listprice : 0,
      }
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
    },
    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeJournal(value, field) {
      this.edit_journal[field] = value;
    },
    onUploadChange(file) {
      if (!file) {return;}
      this.upload.itemimage = file;
      this.upload.imagename = file.name;
    },
    async updateInventoryJournal() {
      this.edit_journal._id = this.initvalue._id;
      await this.updateInventoryJournalRequest(this.edit_journal);
      router.push("/inventoryjournal/list");
    },
    updateTransactionDialog(payload){
      console.log(payload)
      let item = this.items.find(i=>i._id==payload.itemid);
      console.log(item)
      let brandid = item.brandid;
      this.isEditTransaction = true;
      this.edit_transaction = Object.assign({brandid: brandid}, payload);
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updateIVJTransactionRequest(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.edit_transaction = {};
      this.getInventoryJournalRequest(this.initvalue._id);
    },
    async uploadFile(){
      this.upload.journalid = this.initvalue._id;
      this.isUploadFile = false;
      let file = await this.insertInventoryJournalFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "InventoryJournalList" });
    this.journaldate = formatStdDate(this.initvalue.journaldate);
    
    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if (this.pricelists.length==0) await this.getPriceListsRequest();

    this.files = this.initvalue.files;
    this.images = this.initvalue.images;
    this.transactions = this.initvalue.transactions;
    this.calculateTotal();
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
